import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'

import './style.css'
import {uploadToS3} from "../../../../../helpers/aws"
import Schema from "../../../../../helpers/schema"
import Spinner from "../../../Spinner"
import NRTButton from "../../../_buttons/Button"
import ClipIcon from "../../../_icons/ClipIcon"
import moment from "moment";

class NRTFileInput extends Component {

    state = {
        imageUrl: null,
        filename: null,
        awaiting: false,
    }


    componentWillMount() {
        if (this.props.value) {
            const begin = this.props.value.lastIndexOf("/") + 1
            const filename = this.props.value.substring(begin)
            this.setState({
                filename: filename
            })
        }
    }


    handleChange = async (props) => {

        const {shouldUploadToS3, s3ParentType} = this.props
        //DELETE imageURL

        let file = this.input.files[0]

        file = new File([file],moment().format('YYYYMMDDhmmss_')+file.name, {type: file.type});

        let newImageUrl = ''
        if (shouldUploadToS3) {
            const schemaInstance = await Schema.get()
            const {schema} = schemaInstance

            this.setState({awaiting: true})
            newImageUrl = await uploadToS3(schema, file, s3ParentType, true)
            this.setState({awaiting: false})
        }

        props.onChange(newImageUrl)
        this.setState({filename: file.name, imageUrl: newImageUrl})
    }

    render() {

        const {
            awaiting
        } = this.state
        const newProps = {
            ...this.props
        }
        delete newProps.value
        delete newProps.s3ParentType
        delete newProps.shouldUploadToS3
        delete newProps.shortVersion

        const awaitingCls = awaiting ? 'awaiting' : ''
        const disableCls = this.props.disabled ? ' disabled' : ''
        return (
            <div className={'nrt-file-input-container'}>

                <div className={"nrt-input-wrapper " + awaitingCls + disableCls}>

                    <input type={'file'}
                           ref={input => this.input = input}
                           {...newProps}
                           onChange={
                               () => this.handleChange(newProps)
                           }
                    />

                    {
                        this.props.shortVersion &&
                        <NRTButton onClick={this.collapseSlave}
                                   secondary
                                   content={
                                       <ClipIcon style={{
                                           width: '1.5rem',
                                           margin: 0,
                                           padding: 0
                                       }}/>
                                   }
                        />
                    }
                    {
                        !this.props.shortVersion &&
                        <Fragment>
                            <div className="input-overlay">
                                {
                                    awaiting ?
                                        <Spinner/> :
                                        <React.Fragment>

                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                                                <path
                                                    d="M50.975 20.694c-.527-9-7.946-16.194-16.891-16.194-5.43 0-10.688 2.663-13.946 7.008-.074-.039-.153-.065-.228-.102a8.621 8.621 0 0 0-.605-.269 8.946 8.946 0 0 0-.961-.317c-.116-.031-.231-.063-.349-.09a8.938 8.938 0 0 0-.683-.124c-.102-.015-.202-.035-.305-.047A9.278 9.278 0 0 0 16 10.5c-4.962 0-9 4.037-9 9 0 .129.007.255.016.381C2.857 22.148 0 26.899 0 31.654 0 38.737 5.762 44.5 12.845 44.5H18a1 1 0 1 0 0-2h-5.155C6.865 42.5 2 37.635 2 31.654c0-4.154 2.705-8.466 6.432-10.253L9 21.13v-.63c0-.123.008-.249.015-.375l.009-.175-.012-.188C9.007 19.675 9 19.588 9 19.5c0-3.859 3.14-7 7-7 .309 0 .614.027.917.067.078.01.155.023.232.036.268.044.532.102.792.177.034.01.069.016.102.026a6.86 6.86 0 0 1 1.043.421A6.995 6.995 0 0 1 23 19.5a1 1 0 1 0 2 0 8.98 8.98 0 0 0-3.2-6.871C24.666 8.879 29.388 6.5 34.084 6.5c7.744 0 14.178 6.135 14.848 13.887-1.022-.072-2.553-.109-4.083.125a1 1 0 1 0 .301 1.977c2.224-.336 4.543-.021 4.684-.002C54.49 23.372 58 27.661 58 32.472 58 38.001 53.501 42.5 47.972 42.5H44a1 1 0 1 0 0 2h3.972C54.604 44.5 60 39.104 60 32.472c0-5.489-3.827-10.412-9.025-11.778z"/>
                                                <path
                                                    d="M31.708 30.794a1.001 1.001 0 0 0-1.416 0l-7.999 7.999a.999.999 0 1 0 1.414 1.414L30 33.914V54.5a1 1 0 1 0 2 0V33.914l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-7.999-7.999z"/>
                                            </svg>

                                            <span>Selecionar arquivo...</span>
                                        </React.Fragment>
                                }

                            </div>

                            {
                                !!this.state.filename &&
                                <div className="filename">
                                    {this.state.filename}
                                </div>
                            }
                        </Fragment>
                    }

                </div>
            </div>

        )
    }
}


NRTFileInput.propTypes = {
    s3ParentType: PropTypes.string,
    shouldUploadToS3: PropTypes.bool,
    shortVersion: PropTypes.bool,
}

NRTFileInput.defaultProps = {
    shouldUploadToS3: false,
    shortVersion: false
}

export default NRTFileInput



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/FileInput/index.js